import { doesWorkflowRejectCodeExist } from '@tassat/common-definitions';

import Worker from 'Lib/worker/PrimusWorker';
import adminStore from 'Reducers/store/adminStore';
import { getPcgNumbersByUser, getPcgUsersArrayByUser } from 'Selectors/pcgUsers';

export const createAndMapPcgUser = async (firmId, userValues) => {
    try {
        const pcgs = userValues.PCGMapping;
        delete userValues.PCGMapping;
        const addUserResponse = await Worker.getInstance()
            .createUser(firmId, userValues);
        const createdUserId = addUserResponse.data.NewRecordId;
        pcgs.map(async (pcg) => await Worker.getInstance()
            .mapPcgUser(createdUserId, pcg.value));

        return addUserResponse;
    } catch (error) {
        return error;
    }
};

export const modifyUserPcgMapping = async (userId, selectedPcgNumbers) => {
    const userPcgs = getPcgNumbersByUser(adminStore.getState(), userId, undefined, undefined);
    const userPcgsArray = getPcgUsersArrayByUser(adminStore.getState(), userId, false, undefined);
    const pcgNumberIds = selectedPcgNumbers.map(pcg => pcg.value);

    const remove = [];
    userPcgsArray.filter(pcgNumber => !pcgNumberIds.includes(pcgNumber.PCGId))
        .forEach(pcg => remove.push(() => Worker.getInstance()
            .unmapPcgUser(pcg.PCGUserId)));

    const add = [];
    pcgNumberIds.filter(id => !userPcgs[id])
        .forEach(pcgId => add.push(() => Worker.getInstance()
            .mapPcgUser(userId, pcgId)));

    Promise.all(remove.length > 0 ? remove.map(promise => promise()) : add.map(promise => promise()))
        .then(result => {
            if (result.includes(response => response?.data?.Status === 49 || doesWorkflowRejectCodeExist(response?.data?.Status))) {
                return 'Error deleting PCG Mapping';
            } else if (remove.length > 0 && add.length > 0) {
                Promise.all(add.map(promise => promise()))
                    .then(result => {
                        return result;
                    })
                    .catch(error => {
                        return error;
                    });
            }
        })
        .catch(error => {
            return error;
        });
};